import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import WarningIcon from "@mui/icons-material/Warning";
import { useSelector } from "react-redux";

export default function SubscriptionExpiredDialog({ open, onClose }) {
  const { darkMode } = useSelector((state) => state.theme);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="subscription-expired-title"
      PaperProps={{
        sx: {
          borderRadius: 2,
          border: "1px solid",
          borderColor: darkMode ? "rgba(255,255,255,0.14)" : "#e2e8f0",
          background: darkMode ? "#111827" : "#ffffff",
          boxShadow: "0 24px 80px rgba(15, 23, 42, 0.28)",
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        id="subscription-expired-title"
        sx={{ display: "flex", alignItems: "center", gap: 1, color: darkMode ? "#fca5a5" : "#b42318" }}
      >
        <WarningIcon />
        Subscription expired
      </DialogTitle>
      <DialogContent sx={{ color: darkMode ? "#fff" : "#000" }}>
        Your subscription has expired. Your account is currently read-only.
        Please renew your subscription to restore full access.
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} autoFocus>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
}
